<template>
<div>
   <!--<Section background="white"  class="image-bg"-->
   <!--         :style="{'background-image': `url(${require('../../assets/images/content/pexels-brett-sayles-992734-cropped.jpg')})`}"-->

   <!--&gt;-->

   <!--   <nav-bar dark></nav-bar>-->
   <!--   &lt;!&ndash;      <div class=" main-heading heading-line pt-1">&ndash;&gt;-->
   <!--   &lt;!&ndash;      </div>&ndash;&gt;-->

   <!--   &lt;!&ndash;      <div class=" main-heading heading-line" style=" width: 100%;" >&ndash;&gt;-->
   <!--   &lt;!&ndash;      </div>&ndash;&gt;-->

   <!--   <div class=" main-heading" style=" width: 100%;" >-->
   <!--      <v-container fluid class="heading-line">-->
   <!--         <div class="center display-2">About Us</div>-->
   <!--      </v-container>-->
   <!--   </div>-->


   <!--</Section>-->


   <v-container class="main-content-container">
      <section id="main_section">
         <article>
            <table width=100% border="0">
               <tr>
                  <td valign="top">
                     <h1>The Namihira's Biography</h1>
                     <p> Yoshinobu Namihira was born in Yonaguni, an island of Japan in 1952.  When he was just one years old, he contracted
                        polio and as a consequence his ability to walk as a child was severely limited.  At the age 13 he had surgery
                        that greatly improved his mobility, an event which instilled in him the desire to become a doctor
                        and help others.
                     </p>
                     <p>
                        Dr. Namihira moved to the US in 1974 as a exchange student, and received his Bachelors in
                        Mathematics from La Sierra College in 1977.  He then studied medicine at Loma Linda University,
                        graduating in 1981, and there after completing his residency in Internal Medicine at Loma Linda
                        in 1984 and then a fellowship in Gastroenterology at the University of Mississippi in 1986.
                     </p>
                     <p>
                        Dr. Namihira is a  Fellow of the American College of Gastroenterology (FACG) and is a member of
                        the American Board of Internal Medicine, the American College of Gastroenterology,
                        and the American Association for Gastroentestinal Endoscopy.
                     </p>
                  </td>
                  <td>
                     &nbsp;
                  </td>
                  <td valign="top" style="padding-left: 10px">
                     <img align="right" src = "../../assets/images/content/dr_mrs_namihira.jpg" width = 250 height=290>
                  </td>
               </tr>
            </table>



            <p>
               Mieko Namihira was born in Osaka Japan.  At the age of 16, she immigrated to the US
               and attended Loma Linda University, graduating in 1972 with her Bachelor degree in Medical Technology.
               She also holds an ASCP certification.
            </p>
            <p>
               Dr. and Mrs. Namihira meet while at college and were married in 1975.  Together they reside in Vicksburg, MS
               where Dr. Namihira has had his practice for the past 30 years.  Today the Namihira's have an active ministry
               in which Dr. Namihira lectures on health and Mrs. Namihira runs an international Radio ministry since 1993 which
               covers four continents.
            </p>



         </article>

      </section>







   </v-container>
</div>
</template>

<script>
import navBar from '@/components/navBar.vue'
import Section from "@/components/Section";


export default {
name: "AboutUs",
   components: {navBar, Section, },
}
</script>

<style scoped>

</style>
